import { render } from "./tab-nav-items.vue?vue&type=template&id=5ac75a42"
import script from "./tab-nav-items.vue?vue&type=script&lang=js"
export * from "./tab-nav-items.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__